import { Report } from "@/types/report";
import React from "react";
import { Styled } from "./styles";
import { useDownload } from "./hooks";

const Attachment: React.FC<Report["attachments"][number]> = attachment => {
    const { name } = attachment;
    const { onDownload } = useDownload(attachment);

    return (
        <Styled.Container>
            <Styled.Name onClick={onDownload} variant="body2">
                {name}
            </Styled.Name>
        </Styled.Container>
    );
};

export default Attachment;
